<!--  -->
<template>
  <div>
    <div style="margin-bottom:10px">
      第{{ index+1 }}组 / 共{{ arr.length }}组
    </div>
    <el-table
      :key="index"
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="scene_name"
        label="场景名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="platform_name"
        label="平台名称"
        width="180"
        align="center"
      />

      <el-table-column
        prop="account_name_a"
        label="公众号名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="data"
        label="副账号"
        align="center"
      >
        <template slot-scope="scope">
          <!-- {{ scope.row.accounts_b }} -->
          <el-button v-if="scope.row.accounts_b.length == 0" type="primary" size="mini" @click="addsubaccount(scope.row.platform_id,scope.row.account_a)">添加副账号</el-button>
          <div v-for="items,indexr in scope.row.accounts_b" v-else :key="indexr">
            <!-- <div class="subaccount_checkbox uncheck">副账号</div>
          <div class="subaccount_checkbox check">副账号</div> -->
            <div class="big_box">
              <div :class="[items.flag == true ? 'check' : '']" class="subaccount_checkbox" @click="chosrws(items,scope.row.accounts_b,scope.row)">{{ items.account_name }}</div>
            </div>

          </div>

        </template>
      </el-table-column>
    </el-table>
    <el-button-group class="ribbon">
      <el-button type="primary" size="mini" icon="el-icon-arrow-left" :disabled="index == 0" @click="previous">上一组</el-button>
      <el-button type="primary" size="mini" :disabled="arr.length-1 == index" @click="next">下一组<i class="el-icon-arrow-right el-icon--right" /></el-button>
    </el-button-group>
    <div class="save_box">
      <el-button type="primary" size="small" @click="save">保存</el-button>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="manydialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="50%"
    >
      <Bindofficialaccountdiatwo ref="chhoseaccout" @closedialog="closedialog" />
    </el-dialog>
  </div>
</template>

<script>
import Bindofficialaccountdiatwo from './Bindofficialaccountdiatwo.vue'
import { strategybindaccout, officialaccountbind, gerwinda, timingcreate } from '@/api/sourceMaterial.js'
export default {
  components: { Bindofficialaccountdiatwo },
  data() {
    return {
      arr: [
        [{
          title: '111',
          data: '2012'
        },
        {
          title: '111',
          data: '2012'
        }
        ],
        [{
          title: '222'
        }, {
          title: '222'
        }]
      ],
      index: 0,
      manydialogVisible: false,
      arrs: [],
      parformid: null,
      accounta: null,
      fileList: [],
      strategy_no: null,
      arrsw: [],
      type: null,
      sendtime: null,
      promlateid: null,
      labelgroupid: null,
      num: null,
      hour: null,
      minute: null
    }
  },
  created() {
    this.tableData = this.arr[this.index]
  },
  mounted() {

  },
  methods: {
    send(val, strategy_no, arrsw, type, sendtime, promlateid, labelgroupid, num, hour, minute) {
      this.arr = []
      this.arr = val
      this.strategy_no = strategy_no
      this.arrsw = arrsw
      this.type = type
      this.sendtime = sendtime
      this.promlateid = promlateid
      this.labelgroupid = labelgroupid
      this.num = num
      this.hour = hour
      this.minute = minute
      console.log('bandAandBview', this.arr, strategy_no, type)
      this.tableData = this.arr[this.index]
    },
    previous() {
      this.tableData = this.arr[this.index -= 1]
      // this.$forceUpdate()
    },
    next() {
      this.tableData = this.arr[this.index += 1]
      // this.$forceUpdate()
    },
    addsubaccount(id, account_a) {
      this.manydialogVisible = true
      this.parformid = id
      this.accounta = account_a
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.chhoseaccout.sendrs(id, this.arrs, account_a)
      }, 100)
    },
    // 选择完 回调
    closedialog(arr) {
      // this.arrs = arr
      console.log('传进来的', arr)
      this.fileList = []
      this.fileList = arr.map((itemr, indexrs) => {
        // eslint-disable-next-line eqeqeq
        return { account_name: itemr.account_name_rel, app_id: itemr.relation_app_id, flag: indexrs == 0 }
      })
      console.log('传进来的处理完的', this.fileList)
      // eslint-disable-next-line eqeqeq
      if (arr.length != 0) {
        console.log('传进来的成功的', arr)
        this.arr.forEach((item, index) => {
          item.forEach((items, indexr) => {
            // eslint-disable-next-line eqeqeq
            if (items.account_a == this.accounta && items.platform_id == this.parformid) {
              items.accounts_b = []
              this.$set(items, 'accounts_b', this.deepCopy(this.fileList))
              this.$set(items, 'account_b', this.fileList[0].app_id)
              this.$forceUpdate()
            }
          })
        })
      }
      this.manydialogVisible = false
      console.log('arrs666', this.arr)
    },
    deepCopy(obj, cache = []) {
      // 如果为普通数据类型，则直接返回，完成拷贝
      if (obj === null || typeof obj !== 'object') {
        return obj
      }
      // cache用来储存原始值和对应拷贝数据，在递归调用deepCopy函数时，如果本次拷贝的原始值在之前已经拷贝了，则直接返回储存中的copy值，这样的话就不用再循环复制本次原始值里面的每一项了。
      // 还有一个更为重要的作用，假如原始值里面嵌套两个引用地址相同的对象，使用cache可以保证拷贝出来的copy值里面两个对象的引用地址也相同。
      // 如果find查找的是一个空数组，则不会执行
      const hit = find(cache, c => c.original === obj)
      if (hit) {
        return hit.copy
      }
      // 定义拷贝的数据类型
      const copy = Array.isArray(obj) ? [] : {}
      // 用来记录拷贝的原始值和copy值
      cache.push[{
        original: obj,
        copy
      }]
      // 递归调用深拷贝函数，拷贝对象中的每一个值
      Object.keys(obj).forEach(key => {
        copy[key] = this.deepCopy(obj[key], cache)
      })
      return copy
    },

    chosrws(item, arr, items) {
      console.log('this.arr', this.arr)
      console.log('item', item)
      console.log('items', items)
      console.log('arr', arr)
      items.account_b = item.app_id
      items.accounts_b.forEach(element => {
        this.$set(element, 'flag', false)
        // element.flag = false
      })
      this.$set(item, 'flag', true)
      // item.flag = true
      this.$forceUpdate()
    },
    async save() {
      console.log('this.arr', this.arr)
      if (this.type === 1) {
        const data = await strategybindaccout({
          app_ids: this.arrsw,
          strategy_no: this.strategy_no,
          choosing: this.arr
        })
        this.$message({
          type: 'success',
          message: `操作成功`
        })
        console.log('data', data)
      } else if (this.type === 2) {
        const data = await officialaccountbind({
          app_ids: this.arrsw,
          menu_id: this.strategy_no,
          choosing: this.arr
        })
        this.$message({
          type: 'success',
          message: `操作成功`
        })
        console.log('data', data)
      } else if (this.type === 3) {
        const data = await gerwinda({
          app_ids: this.arrsw,
          articles_template_id: this.strategy_no,
          send_time: this.sendtime,
          platform_id: this.promlateid,
          tag_group_ids: this.labelgroupid,
          timing_del: this.num,
          choosing: this.arr
        })
        this.$message({
          type: 'success',
          message: `操作成功`
        })
        console.log('data', data)
      } else if (this.type === 4) {
        const data = await timingcreate({
          app_ids: this.arrsw,
          articles_template_id: this.strategy_no,
          hour: this.hour,
          minute: this.minute,
          platform_id: this.promlateid,
          tag_group_ids: this.labelgroupid,
          choosing: this.arr
        })
        this.$message({
          type: 'success',
          message: `操作成功`
        })
        console.log('data', data)
      }
      this.$emit('saveupdata')
    }
  }

}
</script>
<style scoped>
/* @import url(); 引入css类 */
.ribbon{
  margin-top: 20px;
}
.save_box{
  margin-top: 20px;
}
.subaccount_checkbox{
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    border: 1px solid #dcdfe6;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    margin: 0;
    font-weight: 500;
    padding: 8px 8px;
    font-size: 14px;
    border-radius: 4px;
}
.uncheck{
    background: #fff;
    color: #606266;
}
.check{
    background: #409eff;
    color: #fff;
}
.big_box{
  margin-right: 10px;
  margin-bottom: 5px;
}
.el-table /deep/ .cell{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

}
</style>
